import type { ReactNode } from 'react';
import { DataTableFooterShell } from './FooterShell';

export interface DataTableRowCountProps {
    count: number;
    trailing?: ReactNode;
    className?: string;
}

/**
 * Footer content for a table with no `pagination` and no mode to toggle
 * (e.g. `PracticeUsersTable`, which fetches its full list up front) - a row
 * count rather than a dead control.
 */
export function DataTableRowCount({ count, trailing, className }: DataTableRowCountProps) {
    return (
        <DataTableFooterShell trailing={trailing} className={className}>
            <span className="text-sm text-gray-500">
                {count} result{count === 1 ? '' : 's'}
            </span>
        </DataTableFooterShell>
    );
}
